import { SupportTicketMessage } from "src/api/rtk/indorsoftRu/slices/supportApiSlice";
import { findLastReadSupportMessage, findLastUserMessage } from "./supportTicketUtils";

/**
 * Скроллит контейнер так, чтобы целевой элемент был в самом верху видимой области
 */
export function scrollToElementTop(container: HTMLElement, target: HTMLElement): void {
    const listTop = container.getBoundingClientRect().top;
    const targetTop = target.getBoundingClientRect().top;
    const currentScroll = container.scrollTop;
    const newScroll = currentScroll + (targetTop - listTop);
    container.scrollTop = newScroll;
}

/**
 * Выполняет "умный" начальный скролл:
 * - если последнее сообщение — от пользователя, скроллим к нему
 * - иначе к последнему прочитанному сообщению поддержки
 * - если не нашли последнее прочитанное сообщение поддержки — к последнему сообщению пользователя
 * - если и его нет — в самый низ
 */
export function smartInitialScroll(
    list: HTMLElement,
    messages: SupportTicketMessage[],
    lastReadId: number,
): void {
    const lastMessage = messages[messages.length - 1];

    // 1) Последнее сообщение от пользователя
    if (lastMessage && lastMessage.MESSAGE_BY_SUPPORT_TEAM !== "Y") {
        const el = list.querySelector<HTMLElement>(`[data-message-id="${lastMessage.ID}"]`);
        if (el) {
            scrollToElementTop(list, el);
            return;
        }
    }

    // 2) Последнее прочитанное сообщение поддержки
    const lastReadSupport = findLastReadSupportMessage(messages, lastReadId);

    if (lastReadSupport) {
        // Проверяем, есть ли сообщения от пользователя после последнего прочитанного сообщения поддержки
        const lastReadSupportIndex = messages.findIndex((m) => m.ID === lastReadSupport.ID);
        const hasUserMessagesAfter = lastReadSupportIndex >= 0 && 
            messages.slice(lastReadSupportIndex + 1).some((m) => m.MESSAGE_BY_SUPPORT_TEAM !== "Y");

        // Если есть сообщения пользователя после последнего прочитанного — скроллим до последнего сообщения пользователя
        if (hasUserMessagesAfter) {
            const lastUserMessage = findLastUserMessage(messages);
            if (lastUserMessage) {
                const el = list.querySelector<HTMLElement>(`[data-message-id="${lastUserMessage.ID}"]`);
                if (el) {
                    scrollToElementTop(list, el);
                    return;
                }
            }
        }

        // Иначе скроллим до последнего прочитанного сообщения поддержки
        const el = list.querySelector<HTMLElement>(`[data-message-id="${lastReadSupport.ID}"]`);
        if (el) {
            scrollToElementTop(list, el);
            return;
        }
    }

    // 3) Если не нашли последнее прочитанное сообщение поддержки — ищем последнее сообщение пользователя
    const lastUserMessage = findLastUserMessage(messages);
    if (lastUserMessage) {
        const el = list.querySelector<HTMLElement>(`[data-message-id="${lastUserMessage.ID}"]`);
        if (el) {
            scrollToElementTop(list, el);
            return;
        }
    }

    // 4) Фолбэк — просто вниз
    list.scrollTop = list.scrollHeight;
}


